(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'degreeOverview', {
            bindings: {
                content:       '<'
            },
            templateUrl:  'app/views/partials/content/degree-overview.html',
            controller:   DegreeOverviewController,
            controllerAs: 'vm',

            renderingOptions: {
                /** @type {RecipeConfig} */
                'content-facts': {
                    inputs:    [
                        'content="::content.asset_contents.content"'
                    ],
                    classes: [
                        'block',
                        'detail-overview',
                        'highlighted'
                    ],
                    wrapStart:     '<div class="centraliser">',
                    wrapEnd:       '</div>',
                    parentClasses: [ 'no-lines' ]
                }
            }
        });


    /**
     * Shows a degree's summary in a compact overview block.
     *
     * @param {ng.IScope} $scope
     * @param {LoggerFactory} LoggerFactory
     * @param {SelectablesService} SelectablesService
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {TrackerService} TrackerService
     * @param {Utils} Utils
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function DegreeOverviewController(
        $scope,
        LoggerFactory,
        SelectablesService,
        ContentSwitchingService,
        TrackerService,
        Utils,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm   = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @constant */
        var ITEMS    = SelectablesService.ITEMS,
        _            = TEXTS.DEGREE.OVERVIEW,

        POSTGRADS_SELECTABLE_ID = 'degreeMajors',
        RESPONSE_TYPE_DEGREE    = 'undergrad',
        RESPONSE_TYPE_PREDEGREE = 'predegree';


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'DegreeOverviewController' );





        /* ===== EXPOSE TO THE SCOPE ==================================== */


        /** @constant */
        $scope.ITEMS    = ITEMS;
        $scope.CONFIG   = CONFIG;
        $scope._        = _;





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        /** @constant */
        vm.KIS_IMAGE_SRC = CONFIG.UI.PATHS.IMAGES.KIS_SQUARE;


        // Methods
        vm.setFeesVisibility = function( feesVisibilityFlag ) {
            vm.areFeesVisible = feesVisibilityFlag;
        };





        /* ===== RUN ON INSTANTIATION =================================== */


        /** @constructor */
        vm.$onInit = function() {
            vm.trackKisCtr      = TrackerService.logKISClick;
            setWatchers();
            initModel();
        };


        /** *MUST BE* present to allow directive `collapsible` to bind to the Controller's $postLink event. */
        Utils.addGenericPostLinkTrigger( vm );





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function initModel() {
            vm.tooltipHeadings  = Utils.getSharedContent().headingsToolTips.asset_contents;
            vm.metadata         = Utils.retrieveMetadataRecursively( $scope );

            if ( vm.metadata ){
                resolveQualificationLabel();
                initMajors( POSTGRADS_SELECTABLE_ID );
                ContentSwitchingService.initInternationalOnObject( vm.metadata );
            } else {
                logger.error( "Qualification is missing a top-level `metadata` attribute - Cannot render its overview card!" );
            }
        }


        function resolveQualificationLabel() {
            // Map API's enum to a label defined by the app
            switch ( vm.metadata.type ) {

                case RESPONSE_TYPE_DEGREE:
                    vm.qualificationLabel = _.LABEL_UNDERGRADUATE;
                    break;

                case RESPONSE_TYPE_PREDEGREE:
                    vm.qualificationLabel = _.LABEL_PREDEGREE;
                    break;

                default: {
                    vm.qualificationLabel = _.LABEL_UNDERGRADUATE;
                    logger.warn( "Unknown type `%s` of the Degree - setting it as `undergrad`.", vm.metadata.type );
                }
            }
        }


        function setWatchers() {
            $scope.$watch( 'ContentSwitchingService.contentType', function() {
                vm.isInternationalContent = ContentSwitchingService.isInternational();

                if ( vm.hasOwnProperty( 'metadata' ) ){
                    vm.degree = vm.isInternationalContent ? vm.metadata[ 'international' ] : vm.metadata;
                }
            });
        }


        function initMajors( selectablesId ) {
            var selectablesObject = SelectablesService.getSelectablesById( selectablesId );

            // Model and states
            vm.majors = selectablesObject.model;
        }

    }



    DegreeOverviewController.$inject = [ '$scope', 'LoggerFactory', 'SelectablesService', 'ContentSwitchingService', 'TrackerService', 'Utils', 'TEXTS', 'CONFIG' ];
})();
